export default {
    name: {
        value: '',
        isError: false
    },
    first_name: {
        value: '',
        isError: false
    },
    birth_date: {
        value: '',
        isError: false
    },
    passport: {
        value: '',
        isError: false
    },
    passport_rf: {
        value: '',
        isError: false
    },
    passport_date: {
        value: '',
        isError: false
    },
    citizenship: {
        value: '',
        isError: false
    },
    phone: {
        value: '',
        isError: false,
    },
    email: {
        value: '',
        isError: false
    },
    t_shirt_size: {
        value: '',
        isError: false
    },
    sex: {
        value: '',
        isError: false
    },
}
